import { FC, Ref } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { withParams } from '@telialt/utils/src/helpers';

import { PriceTag } from '../../components/PriceTag';
import { ORDER_CART_TEST_ID } from '../../constants';
import { CartTotalsData } from '../../model';
import { CartGroupTotals, Separator, TermMonthly, TermTotal, ValueMonthly, ValueTotal } from './CartTotals.styles';

export const CartTotals: FC<{ data: CartTotalsData }> = ({ data }) => {
    const { t } = useTranslations();

    const {
        totalPrice,
        monthlyPrice,
        totalPriceLabel,
        isTotalMonthlyPrice,
        futurePrice,
        futurePriceDate,
        cartTotalsRef,
    } = data;

    return (
        <CartGroupTotals ref={cartTotalsRef as Ref<HTMLDListElement>} data-test={ORDER_CART_TEST_ID.TOTALS}>
            {!!monthlyPrice && (
                <>
                    <TermMonthly>{t['order_cart.totals.monthly_price_label']}</TermMonthly>
                    <ValueMonthly>
                        <PriceTag
                            price={monthlyPrice}
                            isMonthly={true}
                            dataTest={ORDER_CART_TEST_ID.PRICE_TOTAL_MONTHLY}
                        />
                    </ValueMonthly>
                </>
            )}

            <Separator />

            <TermTotal>{totalPriceLabel}</TermTotal>
            <ValueTotal>
                <PriceTag
                    price={totalPrice}
                    isMonthly={isTotalMonthlyPrice}
                    dataTest={ORDER_CART_TEST_ID.PRICE_TOTAL}
                />
            </ValueTotal>

            <Separator />

            {!!futurePrice && !!futurePriceDate && (
                <>
                    <TermMonthly>
                        {withParams(t['order_cart.totals.future_price_label'], { date: futurePriceDate })}
                    </TermMonthly>
                    <ValueMonthly>
                        <PriceTag
                            price={futurePrice}
                            isMonthly={true}
                            dataTest={ORDER_CART_TEST_ID.PRICE_FUTURE_TOTAL}
                        />
                    </ValueMonthly>
                </>
            )}
        </CartGroupTotals>
    );
};
